import { defineMessages, IntlShape } from "react-intl";

import ClassificationMethod from "@app/scene/map/store/layers/boundaries/types/ClassificationMethod";

const messages = defineMessages({
  [ClassificationMethod.EQUAL_INTERVAL]: {
    id: "map.layer.boundaries.demography.edit.equalInterval.title",
    defaultMessage: "Equal Interval",
    description: "Equal Interval Label",
  },
  [ClassificationMethod.NATURAL_BREAKS]: {
    id: "map.layer.boundaries.demography.edit.naturalBreaks.title",
    defaultMessage: "Natural Breaks",
    description: "Natural Breaks label",
  },
  [ClassificationMethod.QUANTILE]: {
    id: "map.layer.boundaries.demography.edit.quantile.title",
    defaultMessage: "Quantile",
    description: "Quantile Label",
  },
});

const getClassificationMethodDisplayName = (
  intl: IntlShape,
  classificationMethod: ClassificationMethod
) => intl.formatMessage(messages[classificationMethod]);

export default getClassificationMethodDisplayName;
